import { takeReturnTo } from "../lib/returnTo";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

// Landing page for the server-side allauth Google flow. The backend redirects
// the browser here with the JWT(s) in the URL *fragment*:
//   /auth/callback#token=<jwt>&refresh=<jwt>
// We capture the token, hand it to AuthContext, then WAIT for the auth state to
// hydrate (GET /me) before navigating into the app — navigating immediately would
// race the route guard (user not loaded yet) and bounce back to the homepage.
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setSession, isAuthenticated, loading } = useAuth();
  const [captured, setCaptured] = useState(false);

  // 1) Capture the token from the fragment exactly once.
  useEffect(() => {
    const hash = window.location.hash.startsWith("#")
      ? window.location.hash.slice(1)
      : window.location.hash;
    const params = new URLSearchParams(hash);
    const token = params.get("token");
    const refresh = params.get("refresh");

    if (token) {
      setSession(token, { refresh });
      setCaptured(true);
    } else {
      navigate("/login", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 2) Once auth has hydrated, go into the app (or back to login if it failed).
  useEffect(() => {
    if (!captured || loading) return;   // still hydrating → keep showing the spinner
    navigate(isAuthenticated ? takeReturnTo("/agentbro") : "/login", { replace: true });
  }, [captured, loading, isAuthenticated, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="text-gray-600 mt-4">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
